import useToken from "../../hooks/token";

export const Logout = () => {

    const [token, setToken] = useToken();
    setToken(null);

    return !!token ? window.location.reload(false) : null
};
export default Logout;